<div class="dialog-container">
  <h2 mat-dialog-title>Fund Line of Credit</h2>
  <div mat-dialog-content>
    <p class="dialog-message">
      Enter the amount you want to fund towards your Personal Line of Credit.
    </p>
    
    <form [formGroup]="paymentForm" (ngSubmit)="onSubmit()">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Amount to Fund</mat-label>
        <input 
          matInput 
          type="text" 
          required numberFormat
          formControlName="amount"
          (input)="updateTotalAmount()">
        <span matPrefix>&nbsp;$&nbsp;</span>
        @if(paymentForm.get('amount')?.hasError('required')) {
          <mat-error>
            Amount is required
          </mat-error>
        }
        @if(paymentForm.get('amount')?.hasError('min')) {
          <mat-error>
            Amount must be greater than $0.01
          </mat-error>
        }
      </mat-form-field>
      
      <div class="info-section">
        <div class="info-row">
          <span class="info-label">Last Month's Interest:</span>
          <span class="info-value">{{selectedBank()?.loc_interest | currency}}</span>
        </div>
        <div class="info-row total">
          <span class="info-label">Total Amount (Funding + Interest):</span>
          <span class="info-value">{{totalAmount | currency}}</span>
        </div>
      </div>
      
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Payment Date</mat-label>
        <input 
          matInput 
          [matDatepicker]="picker" 
          formControlName="date"
          required>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        @if(paymentForm.get('date')?.hasError('required')) {
          <mat-error>
            Date is required
          </mat-error>
        }
      </mat-form-field>
    </form>
  </div>
  
  <div mat-dialog-actions align="end">
    <button 
      mat-button 
      type="button" 
      (click)="onCancel()">
      Cancel
    </button>
    <button 
      mat-raised-button 
      color="primary" 
      type="submit" 
      [disabled]="paymentForm.invalid" 
      (click)="onSubmit()">
      <span>Fund LOC</span>
    </button>
  </div>
</div>
